module.exports = __webpack_public_path__ + "static/media/company_profile_darkmode.dbe58b5b.svg";